import React from 'react';
import { Typography, Box, IconButton, Divider, useTheme } from '@mui/material';
import { Close, Done } from '@mui/icons-material';

interface ColumnHeaderIsSharedProps {
    headerText: string;
    disabled: boolean;
    onToggle?: (check: boolean) => void;
}

const ColumnHeaderIsShared: React.FC<ColumnHeaderIsSharedProps> = ({
    headerText,
    disabled,
    onToggle
}) => {

    const handleToggle = (e: React.MouseEvent<HTMLButtonElement>, checked: boolean) => {
        e.preventDefault();
        e.stopPropagation();

        if (onToggle) {
            onToggle(checked);
        }
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 5px' }}>
            <Typography variant="body2" sx={{ ml: 0.5, mr: 1, fontWeight: 'bold', marginTop: '5px', fontSize: '12px' }}>
                {headerText}
            </Typography>
            <Divider orientation="vertical" flexItem />
            <Box display={'flex'} alignItems={'center'} >
                <IconButton disabled={disabled} size="small" sx={{ padding: '2px' }} onClick={(e) => handleToggle(e, true)}>
                    <Done color={'primary'} />
                </IconButton>
                <IconButton disabled={disabled} size="small" sx={{ padding: '2px' }} onClick={(e) => handleToggle(e, false)}>
                    <Close color={'primary'} />
                </IconButton>
            </Box>
        </Box>
    );
};

export default ColumnHeaderIsShared;
